/*
 * Copyright (c) 2025 by PROS, Inc.  All Rights Reserved.
 * This software is the confidential and proprietary information of
 * PROS, Inc. ("Confidential Information").
 * You may not disclose such Confidential Information, and may only
 * use such Confidential Information in accordance with the terms of
 * the license agreement you entered into with PROS.
 */
import * as clipboard from 'clipboard-polyfill';
/**
 * Copy to clipboard.
 */
export async function copyToClipboard(textPlain, textHtml) {
    const items = {};
    items['text/plain'] = new Blob([textPlain], { type: 'text/plain' });
    // add html if any.
    if (textHtml) {
        items['text/html'] = new Blob([textHtml], { type: 'text/html' });
    }
    const item = new clipboard.ClipboardItem(items);
    await clipboard.write([item]);
}
//# sourceMappingURL=clipboard.js.map